import { z } from "zod";

const jsonObjectSchema = z.record(z.string(), z.json());

export const editorSnapshotSchema = z.object({
  elements: z.array(jsonObjectSchema),
  appState: jsonObjectSchema,
  viewport: z.object({
    scrollX: z.number().finite(),
    scrollY: z.number().finite(),
    zoom: z.number().finite().positive(),
  }),
});

export type EditorSnapshot = z.infer<typeof editorSnapshotSchema>;

const serializedSceneSchema = z.object({
  elements: z.array(jsonObjectSchema),
  appState: jsonObjectSchema,
});

/** Parses the editor's own serializer back into Shotboard-owned JSON values. */
export function parseSerializedScene(
  raw: string,
  viewport: EditorSnapshot["viewport"],
): EditorSnapshot {
  let value: unknown;
  try {
    value = JSON.parse(raw);
  } catch {
    throw new Error("The editor returned invalid serialized data.");
  }

  const scene = serializedSceneSchema.parse(value);
  return editorSnapshotSchema.parse({ ...scene, viewport });
}

/** Creates a public Excalidraw envelope for a new draft. */
export function createEmptySceneJson(): string {
  return JSON.stringify({
    type: "excalidraw",
    version: 2,
    source: "shotboard",
    elements: [],
    appState: {
      currentItemRoughness: 0,
      gridSize: null,
      objectsSnapModeEnabled: true,
      viewBackgroundColor: "#ffffff",
    },
    files: {},
  });
}
